import { Stat } from "@chakra-ui/react"
import Figure from "@hydrologiq/shared/figures/generic/Figure"
import { EnergyUnit } from "@hydrologiq/common/types/energy/consumption"
import { roundToDP } from "@hydrologiq/common/helpers/math"
import { formatRunDryMinutes } from "@hydrologiq/shared/asset/attributes/RunDry"
import FigureContent from "@hydrologiq/shared/figures/generic/FigureContent"

export interface MinWeightProps {
  weight: number
  pressure?: number
}

export interface ForecastedFuelProps {
  days: number | null
  heading?: string
  debug?: boolean
  unit?: EnergyUnit
  currentLevel?: number
  minWeight?: MinWeightProps
  loading?: boolean
  error?: string
  isPlaceholder?: boolean
  compact?: boolean
}

function ForecastedFuel({
  days,
  heading = "Fuel remaining",
  debug = false,
  unit,
  currentLevel,
  minWeight,
  loading,
  error,
  isPlaceholder,
  compact,
}: ForecastedFuelProps) {
  const weightToShow = !!minWeight && !!currentLevel ? currentLevel - minWeight.weight : currentLevel


  const minutes = typeof days === "number" ? days * 24 * 60 : null

  const pending = ((minutes ?? 0) < 0) ? true : false && !loading
  return (
    <Figure heading={heading} loading={loading} error={error} isPlaceholder={isPlaceholder || pending} compact={compact}>
      <FigureContent.Root compact={compact}>
        <FigureContent.SubText compact={compact}>estimated</FigureContent.SubText>
        <FigureContent.Value compact={compact}>
          {typeof minutes === "number" && !Number.isNaN(minutes) ? (
            <>
              {formatRunDryMinutes(minutes, true)}
            </>
          ) : (
            "Waiting for more data"
          )}
        </FigureContent.Value>
        {!compact && unit && weightToShow && !Number.isNaN(weightToShow) && (
          <FigureContent.Label compact={compact}>
            usable hydrogen{" "}
            <b>
              {roundToDP(weightToShow, 1)}
              {unit}
            </b>
          </FigureContent.Label>
        )}
      </FigureContent.Root>

    </Figure>
  )
}

export default ForecastedFuel
